import { styled, Box } from '@mui/material';

export const DashboardVariantV2CarrierContentCollectTabTrackingContainer =
  styled(Box)(({ theme }) => ({
    display: 'flex',
    flex: 1,
    borderTop: '1px solid #dee2e6',
    padding: theme.spacing(1.5),
    gap: theme.spacing(4),
  }));
